import React from "react";

import { useTranslation } from "next-i18next";
import Image from "next/image";

import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";

import ArrowRightSmall from "~public/icons/Arrow Right Small/Arrow Right Small.svg";

export const JoinCommunitySection = (): JSX.Element => {
  const theme = useTheme();
  const isGreaterThanTablet = useMediaQuery(theme.breakpoints.up("md"));

  const { t } = useTranslation("chefspage");
  return (
    <Box>
      <Image
        alt={"image1"}
        layout={"responsive"}
        width={100}
        height={isGreaterThanTablet ? (512 / 1920) * 100 : (1082 / 1920) * 100}
        src={
          isGreaterThanTablet
            ? "/images/searchpage/desktop-picture-one.webp"
            : "/images/homepage/image2.webp"
        }
        style={{ width: "100%", display: "block" }}
      />
      <Box
        sx={{
          bgcolor: "green.main",
          px: 2,
          py: 3
        }}>
        <Box
          sx={{
            maxWidth: { md: "1180px" },
            width: { md: "100%" },
            margin: { md: "0 auto" },
            display: "flex",
            gap: 1.25,
            flexDirection: "column",
            alignItems: "center",
            "&>:nth-of-type(odd)": {
              alignSelf: "start"
            },
            "&>:nth-of-type(even)": {
              alignSelf: "end"
            }
          }}>
          <Typography
            sx={{
              alignSelf: "start",
              fontSize: { xs: 28, md: 96 }
            }}
            fontWeight={500}>
            {t("join-community.text1")}
          </Typography>
          <Typography
            sx={{
              alignSelf: "end",
              fontSize: { xs: 28, md: 96 }
            }}
            fontWeight={500}
            color={"white.main"}>
            {t("join-community.text2")}
          </Typography>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2
            }}>
            <Typography
              sx={{
                alignSelf: "end",
                fontSize: { xs: 28, md: 96 }
              }}
              fontWeight={500}>
              {t("join-community.text3")}
            </Typography>
            <Button
              fullWidth
              href={"/create-recipe"}
              variant={"outlined"}
              sx={{
                zIndex: 1000,
                flex: 1,
                "& path": { fill: "#344054" },
                maxWidth: { md: "378px" },
                marginRight: { md: "80px" },
                fontSize: { md: 32 }
              }}
              endIcon={<ArrowRightSmall />}>
              {t("join-community.button")}
            </Button>
          </Box>
        </Box>
      </Box>
      <Image
        alt={"Chef cooks shrimp"}
        layout={"responsive"}
        width={100}
        height={isGreaterThanTablet ? (500 / 1920) * 100 : (1080 / 1920) * 100}
        src={
          isGreaterThanTablet
            ? "/images/chefspage/desktop-picture-two.png"
            : "/images/homepage/image3.webp"
        }
        style={{ width: "100%", display: "block" }}
      />
    </Box>
  );
};
